import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const BackToTopButton = () => {
  const { t, i18n } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  // Check if we should show the button based on scroll position
  const checkScrollPosition = () => {
    const scrollY = window.scrollY;

    // Show button when scrolled more than 200px (when first cards start going out of view)
    setIsVisible(scrollY > 200);
  };

  // Scroll to top with smooth animation
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Add scroll event listener
  useEffect(() => {
    const handleScroll = () => {
      checkScrollPosition();
    };

    // Check initial position
    checkScrollPosition();

    // Add scroll listener
    window.addEventListener("scroll", handleScroll, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Don't render if not visible
  if (!isVisible) {
    return null;
  }

  return (
    <button
      onClick={scrollToTop}
      className={`
        fixed bottom-[72px] sm:bottom-4 end-4 
        w-12 h-12 
        bg-blue-500 hover:bg-blue-600 
        text-white 
        rounded-full 
        shadow-lg hover:shadow-xl 
        transition-all duration-300 
        transform hover:scale-105 
        focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-offset-2
        z-50
        touch-target
        ${isVisible ? "opacity-100" : "opacity-0"}
      `}
      aria-label={t("back_to_top")}
      title={t("back_to_top")}
    >
      <svg
        className="w-6 h-6 mx-auto"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 10l7-7m0 0l7 7m-7-7v18"
        />
      </svg>
    </button>
  );
};

export default BackToTopButton;
